// Helpers de precio compartidos por Servicios, la pagina publica de reservas
// y el panel del Agente de WhatsApp. El valor numerico base (`price`) es lo
// unico que usan reportes/margenes/ingreso potencial - esto es solo para
// mostrar el precio "humano" en pantalla.

export const PRICE_TYPE_OPTIONS = [
  { value: "fijo", label: "Fijo" },
  { value: "desde", label: "Desde" },
  { value: "por unidad", label: "Por unidad" },
  { value: "por sesion", label: "Por sesión" },
];

export const SERVICE_CATEGORIES = ["Inyectables", "Faciales y piel", "Contorno corporal"];

function formatAmount(price) {
  const n = Number(price) || 0;
  if (Number.isInteger(n)) return `$${n.toLocaleString("en-US")}`;
  return `$${n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function formatPrice(price, priceType = "fijo", priceNote = null) {
  const amount = formatAmount(price);
  let text = amount;
  if (priceType === "desde") text = `Desde ${amount}`;
  else if (priceType === "por unidad") text = `${amount} por unidad`;
  else if (priceType === "por sesion") text = `${amount} por sesión`;
  if (priceNote) {
    const note = priceNote.trim();
    text += note.toLowerCase().startsWith("por ") ? ` ${note}` : ` (${note})`;
  }
  return text;
}

// Devuelve el precio "regular" (tachado) y el "efectivo" (destacado) segun
// si el servicio tiene una promocion activa (`service.pricing`, calculado
// por el backend). Usado en Servicios, la pagina publica y el agente.
export function getEffectivePricingDisplay(service) {
  const pricing = service.pricing;
  const priceType = service.price_type || "fijo";
  const priceNote = service.price_note;
  if (pricing?.promo_active) {
    return {
      isPromoActive: true,
      regularText: formatPrice(pricing.regular_price, priceType, null),
      promoText: formatPrice(pricing.effective_price, priceType, priceNote),
      promoLabel: pricing.promo_label,
    };
  }
  return {
    isPromoActive: false,
    regularText: formatPrice(service.price, priceType, priceNote),
    promoText: null,
    promoLabel: null,
  };
}

// Fix AT (2026-10-27): el precio para el sello redondo de la pagina publica: monto grande, aclaracion chica
// ("Desde", "por unidad", "por sesión") y, si hay promocion, el monto normal tachado. La nota del precio
// ("por 3 sesiones") queda aparte porque no entra en el circulo.
const PRICE_QUALIFIERS = { desde: "Desde", "por unidad": "por unidad", "por sesion": "por sesión" };

export function getPriceBadge(service) {
  const pricing = service.pricing;
  const promo = Boolean(pricing?.promo_active);
  const priceType = service.price_type || "fijo";
  const amount = formatAmount(promo ? pricing.effective_price : service.price);
  const qualifier = PRICE_QUALIFIERS[priceType] || null;
  return {
    amount,
    qualifier,
    isPromoActive: promo,
    regularAmount: promo ? formatAmount(pricing.regular_price) : null,
    note: service.price_note ? service.price_note.trim() : null,
    label: getEffectivePricingDisplay(service).promoText || getEffectivePricingDisplay(service).regularText,
  };
}

export const SERVICE_KIND_OPTIONS = [
  { value: "treatment", label: "Tratamiento" },
  { value: "consultation", label: "Valoración / Primera consulta" },
  { value: "review", label: "Revisión / Control" },
  { value: "model", label: "Convocatoria de modelo" },
];

export const SERVICE_KIND_BADGE_LABELS = {
  consultation: "Valoración",
  review: "Revisión",
  model: "Modelo",
};

export const PAYMENT_MODE_OPTIONS = [
  { value: "none", label: "Sin pago" },
  { value: "deposit", label: "Seña" },
  { value: "full", label: "Pago total" },
];

export const SERVICE_PAYMENT_OVERRIDE_OPTIONS = [
  { value: "inherit", label: "Heredar de la clínica" },
  ...PAYMENT_MODE_OPTIONS,
];
